module.exports = __webpack_public_path__ + "static/media/nestje4.09fee89f.webp";